import styled, { css } from 'styled-components';

export const Tabs = styled.ul`
  list-style-type: none;
`;

Tabs.displayName = 'Tabs';

type ActiveProps = {
  active: boolean;
  disabled?: boolean;
};

const tabItemModifiers = {
  active: () => css`
    color: var(--gray-900);
    border-color: var(--gray-900);
    cursor: default !important;
  `,
  disabled: () => css`
    border-color: var(--gray-900);
    cursor: not-allowed !important;
    opacity: 0.5;
  `
};

export const TabItem = styled.li<ActiveProps>`
  width: 50%;
  height: 2.625rem;
  color: var(--gray-700);
  border-bottom: 3px solid transparent;
  cursor: pointer !important;
  transition: border ease-out 0.2s;

  ${({ active, disabled }) => css`
    ${active && tabItemModifiers.active()}
    ${disabled && tabItemModifiers.disabled()}
  `}
`;

TabItem.displayName = 'TabItem';
